import React from "react";
import FilterSearch from "./Location/FilterSearch";
import FilterRange from "./Location/FilterRange";

const FilterLocation = ({ location, onLocationChange, distance, onDistanceChange }) => {
    return (
        <>
            <FilterSearch
                label="Location"
                id="locationInput"
                placeholder="Search location"
                value={location}
                onChange={onLocationChange}
            />
            <FilterRange
                id="customRange"
                value={distance}
                onChange={onDistanceChange}
                leftLabel="1miles"
                rightLabel="40miles"
            />
        </>
    );
};

export default FilterLocation;